import { IDoctors } from "./models";

export const doctorItems: IDoctors[] = [
  {
    id: "1",
    sector: "100",
  },
  {
    id: "2",
    sector: "200",
  },
];
